(function (window, document) {
    const savedTheme = localStorage.getItem('theme');
    const leftIcon = document.getElementsByClassName("contrast-left");
    const rightIcon = document.getElementsByClassName("contrast-right");
    const logo = document.getElementById("visio_logo");
    const logoInverted = document.getElementById("visio_logo_inverted");

    if (savedTheme) {
        document.body.classList.add(savedTheme);
        leftIcon[0].classList.add("active")
        rightIcon[0].classList.add("active")
        logo.classList.add("hidden");
        logoInverted.classList.remove("hidden");
    }

    const themeToggle = document.querySelectorAll('#theme-toggle');
    themeToggle.forEach(span => {
        span.addEventListener('click', () => {
            const body = document.body
            body.classList.toggle('contrast');
            const newTheme = document.body.classList.contains('contrast') ? 'contrast' : '';
            localStorage.setItem('theme', newTheme);

            if (document.body.classList.contains('contrast')) {
                leftIcon[0].classList.add("active")
                rightIcon[0].classList.add("active")
                logo.classList.add("hidden");
                logoInverted.classList.remove("hidden");
            } else {
                leftIcon[0].classList.remove("active")
                rightIcon[0].classList.remove("active")
                logo.classList.remove("hidden");
                logoInverted.classList.add("hidden");
            };
        });
    })


    const fontSizes = ['small', 'medium', 'large'];
    const fontSpanElements = document.querySelectorAll('.font-size');
    const savedFontSize = localStorage.getItem('fontSize');

    if (fontSizes.includes(savedFontSize)) {
        document.body.classList.add(`${savedFontSize}`);
    } else {
        document.body.classList.add('small');
    }

    fontSpanElements.forEach(span => {
        span.addEventListener('click', () => {
            const selectedSize = span.dataset.size;

            fontSizes.forEach(size => {
                if (size === selectedSize) {
                    document.body.classList.add(`${size}`);
                    localStorage.setItem('fontSize', size);
                } else {
                    document.body.classList.remove(`${size}`);
                }
            });
        });
    });

    const menuButton = document.getElementById("open-menu");
    const overlay = document.getElementById("overlay");
    const targetElement = document.getElementById("scrollToTop");

    const toggleMenuIcon = (element) => {
        element.classList.toggle("fa-bars");
        element.classList.toggle("fa-times");
    };

    menuButton.addEventListener('click', () => {
        document.body.classList.toggle("menu-open");
        overlay.classList.toggle("hidden");
        targetElement.scrollIntoView({ behavior: 'smooth' });
        let hasOverlay = overlay.classList.contains("hidden");
        if (!hasOverlay) {
            document.body.classList.add("fixed");
        } else {
            document.body.classList.remove("fixed");
        };
        toggleMenuIcon(menuButton);

    });

    overlay.addEventListener('click', () => {
        document.body.classList.toggle("menu-open");
        overlay.classList.toggle("hidden");
        toggleMenuIcon(menuButton);
    });

    // $.fn.setup_navigation = function(options) {
    //     var settings = $.extend({
    //         menuHoverClass: "show-menu"
    //     }, options);
    
    //     var menuItems = $(this).find("> li > a");
    
    //     menuItems.next("ul").attr({
    //         "aria-hidden": "false",
    //         role: "menu"
    //     }).find("a").attr("tabIndex", -1);
    
    //     menuItems.each(function() {
    //         if ($(this).next("ul").length > 0) {
    //             $(this).parent("li").attr("aria-haspopup", "true");
    //         }
    //     });
    
    //     menuItems.hover(function() {
    //         handleMenuItemInteraction($(this), settings);
    //     });
    
    //     menuItems.focus(function() {
    //         handleMenuItemInteraction($(this), settings);
    //     });
    
    //     menuItems.keydown(function(e) {
    //         handleKeyDownEvent($(this), e, settings);
    //     });
    
    //     var submenuItems = menuItems.parent("li").find("ul").find("a");
    
    //     submenuItems.keydown(function(e) {
    //         handleSubmenuKeyDownEvent($(this), e, settings);
    //     });
    
    //     menuItems.find("a").last().keydown(function(e) {
    //         if (e.keyCode === 9) {
    //             $("." + settings.menuHoverClass).attr("aria-hidden", "false").removeClass(settings.menuHoverClass).find("a").attr("tabIndex", -1);
    //         }
    //     });
    
    //     menuItems.mouseleave(function() {
    //         $("." + settings.menuHoverClass).attr("aria-hidden", "false").removeClass(settings.menuHoverClass).find("a").attr("tabIndex", -1);
    //     });
    
    //     $(document).click(function() {
    //         $("." + settings.menuHoverClass).attr("aria-hidden", "false").removeClass(settings.menuHoverClass).find("a").attr("tabIndex", -1);
    //     });
    
    //     $(this).click(function(e) {
    //         e.stopPropagation();
    //     });
    
    //     function handleMenuItemInteraction(item, settings) {
    //         item.closest("ul").attr("aria-hidden", "false").find("." + settings.menuHoverClass).attr("aria-hidden", "false").removeClass(settings.menuHoverClass).find("a").attr("tabIndex", -1);
    //         item.next("ul").attr("aria-hidden", "false").addClass(settings.menuHoverClass).find("a").attr("tabIndex", 0);
    //     }
    
    //     function handleKeyDownEvent(item, event, settings) {
    //         var keyCode = event.keyCode;
    
    //         switch (keyCode) {
    //             case 37:
    //                 handleArrowKey(item, "left");
    //                 break;
    //             case 38:
    //                 handleArrowKey(item, "up", settings);
    //                 break;
    //             case 39:
    //                 handleArrowKey(item, "right");
    //                 break;
    //             case 40:
    //                 handleArrowKey(item, "down", settings);
    //                 break;
    //             case 13:
    //             case 32:
    //                 handleEnterSpaceKey(item);
    //                 break;
    //             case 27:
    //                 handleEscapeKey(settings);
    //                 break;
    //             default:
    //                 handleAlphabetKey(item, keyCode);
    //         }
    //     }
    
    //     function handleSubmenuKeyDownEvent(item, event, settings) {
    //         var keyCode = event.keyCode;
    
    //         // Handle submenu keydown events
    //         // Add your logic here
    //     }
    
    //     function handleArrowKey(item, direction, settings) {
    //         // Handle arrow key events
    //         // Add your logic here
    //     }
    
    //     function handleEnterSpaceKey(item) {
    //         // Handle enter and space key events
    //         // Add your logic here
    //     }
    
    //     function handleEscapeKey(settings) {
    //         $("." + settings.menuHoverClass).attr("aria-hidden", "false").removeClass(settings.menuHoverClass).find("a").attr("tabIndex", -1);
    //     }
    
    //     function handleAlphabetKey(item, keyCode) {
    //         // Handle alphabet key events
    //         // Add your logic here
    //     }
    // };
    
    $.fn.setup_navigation = function(options) {
        var settings = $.extend({
            menuHoverClass: "show-menu"
        }, options);
    
        // Target the specific ul with id "domeinmenu"
        var menuItems = $("#domeinmenu").find("> li > a");
    
        menuItems.next("ul").attr({
            "aria-hidden": "false",
            role: "menu"
        }).find("a").attr("tabIndex", -1);
    
        menuItems.each(function() {
            if ($(this).next("ul").length > 0) {
                $(this).parent("li").attr("aria-haspopup", "true");
            }
        });
    
        menuItems.hover(function() {
            handleMenuItemInteraction($(this), settings);
        });
    
        menuItems.focus(function() {
            handleMenuItemInteraction($(this), settings);
        });
    
        menuItems.keydown(function(e) {
            handleKeyDownEvent($(this), e, settings);
        });
    
        var submenuItems = menuItems.parent("li").find("ul").find("a");
    
        submenuItems.keydown(function(e) {
            handleSubmenuKeyDownEvent($(this), e, settings);
        });
    
        menuItems.find("a").last().keydown(function(e) {
            if (e.keyCode === 9) {
                $("." + settings.menuHoverClass).attr("aria-hidden", "false").removeClass(settings.menuHoverClass).find("a").attr("tabIndex", -1);
            }
        });
    
        menuItems.mouseleave(function() {
            $("." + settings.menuHoverClass).attr("aria-hidden", "false").removeClass(settings.menuHoverClass).find("a").attr("tabIndex", -1);
        });
    
        $(document).click(function() {
            $("." + settings.menuHoverClass).attr("aria-hidden", "false").removeClass(settings.menuHoverClass).find("a").attr("tabIndex", -1);
        });
    
        $(this).click(function(e) {
            e.stopPropagation();
        });
    
        function handleMenuItemInteraction(item, settings) {
            item.closest("ul").attr("aria-hidden", "false").find("." + settings.menuHoverClass).attr("aria-hidden", "false").removeClass(settings.menuHoverClass).find("a").attr("tabIndex", -1);
            item.next("ul").attr("aria-hidden", "false").addClass(settings.menuHoverClass).find("a").attr("tabIndex", 0);
        }
    
        function handleKeyDownEvent(item, event, settings) {
            var keyCode = event.keyCode;
    
            switch (keyCode) {
                case 37:
                    handleArrowKey(item, "left");
                    break;
                case 38:
                    handleArrowKey(item, "up", settings);
                    break;
                case 39:
                    handleArrowKey(item, "right");
                    break;
                case 40:
                    handleArrowKey(item, "down", settings);
                    break;
                case 13:
                case 32:
                    handleEnterSpaceKey(item);
                    break;
                case 27:
                    handleEscapeKey(settings);
                    break;
                default:
                    handleAlphabetKey(item, keyCode);
            }
        }
    
        function handleSubmenuKeyDownEvent(item, event, settings) {
            var keyCode = event.keyCode;
    
            // Handle submenu keydown events
            // Add your logic here
        }
    
        function handleArrowKey(item, direction, settings) {
            // Handle arrow key events
            // Add your logic here
        }
    
        function handleEnterSpaceKey(item) {
            // Handle enter and space key events
            // Add your logic here
        }
    
        function handleEscapeKey(settings) {
            $("." + settings.menuHoverClass).attr("aria-hidden", "false").removeClass(settings.menuHoverClass).find("a").attr("tabIndex", -1);
        }
    
        function handleAlphabetKey(item, keyCode) {
            // Handle alphabet key events
            // Add your logic here
        }
    };

    $.fn.setup_navigation();
    


    window.addEventListener("resize", () => {
        if (window.innerWidth > 768) {
            document.body.classList.remove("menu-open");
            document.body.classList.remove("fixed");
            let hasOverlay = overlay.classList.contains("hidden");
            if (!hasOverlay) {
                overlay.classList.add("hidden");
            };

            if (!!menuButton.classList.contains("fa-times")) {
                toggleMenuIcon(menuButton);
            };
        }
    });
})(window, document);